import React, { useState } from "react";
import "./View_applications.css";
import { Button, Offcanvas } from "react-bootstrap";
import successAnimation from "../../../animation/success_lottie/Success_lottie.json";
import rejectAnimation from "../../../animation/success_lottie/Reject_lottie.json";
import Success_modal from "../../common_modal/success_modal/Success_modal";
import Add_note_modal from "../../common_modal/add_note_modal/Add_note_modal";

function View_applications({ show, handleClose }) {
  const [modalSuccessShow, setModalSuccessShow] = useState(false);
  const [modalRejectShow, setModalRejectShow] = useState(false);
  const [modalAddNoteShow, setModalAddNoteShow] = useState(false);

  const handleApprove = () => {
    setModalSuccessShow(true);
    handleClose();
  };

  const handleReject = () => {
    setModalRejectShow(true);
    handleClose();
  };

  const handleAddNote = () => {
    setModalAddNoteShow(true);
    handleClose();
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="view_application_canvas"
      >
        <Offcanvas.Body>
          <div className="common_doc_card">
            {/* Header */}
            <div className="card_header">
              <h5>Application ID: APP-10234</h5>
              <span className="status_badge pending">Under Review</span>
            </div>

            {/* User Info */}
            <div className="user_info_holder">
              <div className="profile_text_img_holder">
                <div className="profile_img_holder">
                  <img
                    className="profile_img"
                    src="/assets/images/profile/profile_1.webp"
                    alt="profile"
                  />
                </div>

                <div className="user_info">
                  <h6>Student: Priyank Sharma</h6>
                  <p>MBA in International Business</p>
                </div>
              </div>

              <span className="status_badge under_review">Under Review</span>
            </div>

            {/* Dates */}
            <div className="info_block">
              <p>
                Submitted On:{" "}
                <strong className="details_text">20 Oct 2025</strong>
              </p>
              <p>
                Last Update:{" "}
                <strong className="details_text">28 Oct 2025</strong>
              </p>
            </div>

            {/* Documents */}
            <div className="documents_block">
              <h6>Documents</h6>

              <div className="document_item">
                <p className="list_text">Resume</p>
                <span className="status_badge signed">Verified</span>
              </div>

              <div className="document_item">
                <p className="list_text">Passport Copy</p>
                <span className="status_badge pending">Pending</span>
              </div>

              <div className="document_item">
                <p className="list_text">Academic Certificates</p>
                <span className="status_badge signed">Verified</span>
              </div>
            </div>

            {/* Payment */}
            <div className="documents_block">
              <h6>Payment</h6>

              <div className="document_item">
                <p className="list_text">Application Fee</p>
                <span className="status_badge signed">Paid</span>
              </div>

              <div className="document_item">
                <p className="list_text">Tuition Fee</p>
                <span className="status_badge pending">Pending</span>
              </div>
            </div>

            {/* Task */}
            <div className="documents_block">
              <h6>Task</h6>

              <div className="document_item">
                <p className="list_text">Upload Internship Agreement</p>
                <span className="status_badge pending">Pending</span>
              </div>
            </div>

            {/* Actions */}
            <div className="action_btns">
              <Button
                className="info_btn action_click"
                onClick={handleApprove}
              >
                Approve Application
              </Button>

              <Button
                className="delete_btn action_click"
                onClick={handleReject}
              >
                Reject Application
              </Button>

              <Button
                className="download_btn action_click"
                onClick={handleAddNote}
              >
                Add Note
              </Button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Modals */}
      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalSuccessShow(false)}
        message_text="Application Approved"
        animationData={successAnimation}
      />

      <Success_modal
        show={modalRejectShow}
        onHide={() => setModalRejectShow(false)}
        message_text="Application Rejected"
        animationData={rejectAnimation}
      />

      <Add_note_modal
        show={modalAddNoteShow}
        onHide={() => setModalAddNoteShow(false)}
      />
    </>
  );
}

export default View_applications;
